import React from 'react';
import BLComponent from '../../core/_BLComponent.jsx';
import CategoryLinks from './_CategoryLinks.jsx';
import PCCList from './PCCList.jsx';
import NothingToShow from './_NothingToShow.jsx';
import { ItemDetailInfo, ItemTypeNameUtil, Page, ItemListUtil } from '../controller/MyCollectionUtils.js';
import { SortTableHeaderIcon } from '../../common/_Icons.jsx';

export default class ListView extends BLComponent {
	constructor(props, context) {
		super(props, context);	// This should come first. 
		this.state = {
			focusOn: -1
		}
	}

	componentDidUpdate() {
		const focusOn = this.state.focusOn;
		
		if (focusOn != -1) {
			const area = document.getElementById("TextareaNote-" + focusOn);
			if (area != null) 
			{
				area.focus();
				area.selectionStart = area.value.length;
			}
			this.setState({focusOn:-1});
		}
		
	}

	render() {
		const { listItem, dispItemType, strSearchKeyword } = this.props.data;
		const listItemView = this.getItemView(listItem);
		const isEmpty = ItemListUtil.isEmptyList(listItem);
		if (isEmpty) {
			return (
				<NothingToShow data={{ itemType: dispItemType, strSearchKeyword: strSearchKeyword }} />
			)
		}
		else {	
			return (
				<section className="personal-inventory__list-body l-margin-top">
					{this.renderListingHeader()}
					{listItemView}
				</section>
			)
		}
	}

	renderListingHeader() {
		const { dispItemType, listingOptions, showCategoryTree } = this.props.data;
		const sortHeaderIconMargin = (!showCategoryTree)?"l-margin-left":"l-margin-left--xxs";
		if (dispItemType != "P") {
			return (
				<div className={"personal-inventory__list-item" + ((showCategoryTree)?"-with-category":"-list") + "  personal-inventory__list-item-list-header l-border--bottom"}>
					<div className="personal-inventory__list-item-list-cell--image text--bold">Picture</div>
					<div className="personal-inventory__list-item-list-cell--item-no text--bold"><label className="" htmlFor="itemNoSortIcon" className="l-cursor-pointer">Item #</label><SortTableHeaderIcon data={{ id: "itemNoSortIcon", iconClass: "l-margin-left", sortingType: 2, sortingDirection: (listingOptions.nListOrder == 0) ? "d" : "u", disabled: (listingOptions.nListSortType != 2) ? true : false }} func={{ clickCallback: (sortType, sortDirection) => this.updateSortingOptions(2, listingOptions.nListOrder) }} /></div>
					<div className="personal-inventory__list-item-list-cell--item-name text--bold"><label htmlFor="itemNameSortIcon" className="l-cursor-pointer">Item Name</label><SortTableHeaderIcon data={{ id: "itemNameSortIcon", iconClass: "l-margin-left", sortingType: 1, sortingDirection: (listingOptions.nListOrder == 0) ? "d" : "u", disabled: (listingOptions.nListSortType != 1) ? true : false }} func={{ clickCallback: (sortType, sortDirection) => this.updateSortingOptions(1, listingOptions.nListOrder) }} /></div>
					<div className="personal-inventory__list-item-list-cell--cond text--bold"><label htmlFor="itemConditionSortIcon" className="l-cursor-pointer">Condition</label><SortTableHeaderIcon data={{ id: "itemConditionSortIcon", iconClass: sortHeaderIconMargin, sortingType: 3, sortingDirection: (listingOptions.nListOrder == 0) ? "d" : "u", disabled: (listingOptions.nListSortType != 3) ? true : false }} func={{ clickCallback: (sortType, sortDirection) => this.updateSortingOptions(3, listingOptions.nListOrder) }} /></div>
					<div className="personal-inventory__list-item-list-cell--qty personal-inventory__list-item-list-qty text--bold text--center"><label htmlFor="itemQtySortIcon" className="l-cursor-pointer">Qty</label><SortTableHeaderIcon data={{ id: "itemQtySortIcon", iconClass: "l-margin-left", sortingType: 5, sortingDirection: (listingOptions.nListOrder == 0) ? "d" : "u", disabled: (listingOptions.nListSortType != 5) ? true : false }} func={{ clickCallback: (sortType, sortDirection) => this.updateSortingOptions(5, listingOptions.nListOrder) }} /></div>
					<div className="text--bold personal-inventory__list-item-list-cell--note"><label htmlFor="itemNoteSortIcon" className="l-cursor-pointer">Notes</label><SortTableHeaderIcon data={{ id: "itemNoteSortIcon", iconClass: "l-margin-left", sortingType: 6, sortingDirection: (listingOptions.nListOrder == 0) ? "d" : "u", disabled: (listingOptions.nListSortType != 6) ? true : false }} func={{ clickCallback: (sortType, sortDirection) => this.updateSortingOptions(6, listingOptions.nListOrder) }} /></div>
				</div>
			)
		}
		else {
			return (
				<div className={"personal-inventory__list-item" + ((showCategoryTree)?"-with-category":"-list") + " personal-inventory__list-item-list-header l-border--bottom"}>
					<div className="personal-inventory__list-item-list-cell--p-image text--bold">Picture</div>
					<div className="personal-inventory__list-item-list-cell--p-item-no text--bold"><label htmlFor="itemNoSortIcon" className="l-cursor-pointer">Item #</label><SortTableHeaderIcon data={{ id: "itemNoSortIcon", iconClass: "l-margin-left", sortingType: 2, sortingDirection: (listingOptions.nListOrder == 0) ? "d" : "u", disabled: (listingOptions.nListSortType != 2) ? true : false }} func={{ clickCallback: (sortType, sortDirection) => this.updateSortingOptions(2, listingOptions.nListOrder) }} /></div>
					<div className="personal-inventory__list-item-list-cell--p-item-name text--bold"><label htmlFor="itemNameSortIcon" className="l-cursor-pointer">Item Name</label><SortTableHeaderIcon data={{ id: "itemNameSortIcon", iconClass: "l-margin-left", sortingType: 1, sortingDirection: (listingOptions.nListOrder == 0) ? "d" : "u", disabled: (listingOptions.nListSortType != 1) ? true : false }} func={{ clickCallback: (sortType, sortDirection) => this.updateSortingOptions(1, listingOptions.nListOrder) }} /></div>
					<div className="personal-inventory__list-item-list-cell--p-color text--bold"><label htmlFor="itemColorSortIcon" className="l-cursor-pointer">Color</label><SortTableHeaderIcon data={{ id: "itemColorSortIcon", iconClass: "l-margin-left--xxs", sortingType: 4, sortingDirection: (listingOptions.nListOrder == 0) ? "d" : "u", disabled: (listingOptions.nListSortType != 4) ? true : false }} func={{ clickCallback: (sortType, sortDirection) => this.updateSortingOptions(4, listingOptions.nListOrder) }} /></div>
					<div className="personal-inventory__list-item-list-cell--p-cond text--bold"><label htmlFor="itemConditionSortIcon" className="l-cursor-pointer">Condition</label><SortTableHeaderIcon data={{ id: "itemConditionSortIcon", iconClass: "l-margin-left--xxs", sortingType: 3, sortingDirection: (listingOptions.nListOrder == 0) ? "d" : "u", disabled: (listingOptions.nListSortType != 3) ? true : false }} func={{ clickCallback: (sortType, sortDirection) => this.updateSortingOptions(3, listingOptions.nListOrder) }} /></div>
					<div className="personal-inventory__list-item-list-cell--p-qty personal-inventory__list-item-list-qty text--bold text--center"><label htmlFor="itemQtySortIcon" className="l-cursor-pointer">Qty</label><SortTableHeaderIcon data={{ id: "itemQtySortIcon", iconClass: "l-margin-left", sortingType: 5, sortingDirection: (listingOptions.nListOrder == 0) ? "d" : "u", disabled: (listingOptions.nListSortType != 5) ? true : false }} func={{ clickCallback: (sortType, sortDirection) => this.updateSortingOptions(5, listingOptions.nListOrder) }} /></div>
					<div className="text--bold personal-inventory__list-item-list-cell--p-note"><label htmlFor="itemNoteSortIcon" className="l-cursor-pointer">Notes</label><SortTableHeaderIcon data={{ id: "itemNoteSortIcon", iconClass: "l-margin-left", sortingType: 6, sortingDirection: (listingOptions.nListOrder == 0) ? "d" : "u", disabled: (listingOptions.nListSortType != 6) ? true : false }} func={{ clickCallback: (sortType, sortDirection) => this.updateSortingOptions(6, listingOptions.nListOrder) }} /></div>
				</div>
			)
		}
	}

	renderItemRowFullSize(item, idx) {
		const { dispItemType, showCategoryTree } = this.props.data;
		const { itemType, itemNoSeq, strItemCondition, bQtyUpdated, bQtyError, qty, itemColorId } = ItemDetailInfo.getInfo(item);
		
		return (
			<div className={"l-border--bottom personal-inventory__list-item" + ((showCategoryTree)?"-with-category":"-list") + " personal-inventory__list-item-list--full-size  " + ((bQtyUpdated && !bQtyError) ? "personal-inventory__list-qty-updated " : (bQtyUpdated && bQtyError) ? "personal-inventory__list-qty-update-err" : (idx % 2 == 1) ? "personal-inventory__list-even" : "")} key={"itemlist-f" + idx}>
				{this.renderFullSizeItemImgCol(item, idx)}
				{this.renderFullSizeItemNoCol(itemType, itemNoSeq, itemColorId)}
				{this.renderFullSizeItemNameCol(item, idx)}
				{this.renderFullSizeItemConditionCol(dispItemType, strItemCondition)}
				{this.renderFullSizeItemQtyCol(dispItemType, item, idx)}
				{this.renderFullSizeItemNoteCol(dispItemType, item, idx)}
				{this.renderFullSizeItemDelCol(dispItemType, item, idx)}
			</div>
		)
	}

	renderColor(ci) {
		const { dispItemType, showCategoryTree } = this.props.data;
		const bNoColorBox = ( ( dispItemType == "P") && showCategoryTree )?true:false;
		if (ci == null) {
			return null;
		}

		if (((dispItemType == "M") || (dispItemType == "G")) && (ci.idColor <= 0)) {
			return null;
		}
		else if ((dispItemType == "P") || (dispItemType == "M") || (dispItemType == "G") || (dispItemType == "A")) {
			const colorHex = "#" + ci.strColorHex;
			return (
				<div className="l-flex">
					{!bNoColorBox && 
						<div className={"personal-inventory__color-select-dropdown-list-rgb-box l-margin-y--auto" + (((ci.idColor == 0) || (ci.idColor == 1)) ? " l-border" : "")} style={{ backgroundColor: colorHex }}></div>
					}
					<div>{ci.strColorName}</div>
				</div>
			)
		}
		else {
			return null;
		}
	}

	renderItemRowSmallSize(item, idx) {
		const { dispItemType } = this.props.data;
		const { itemType, itemNoSeq, itemName, strItemCondition, invURL, catNames, catIds, ci, bQtyUpdated, bQtyError, qty, isRenderColorInfo, bMarkedAsDeletion, itemColorId } = ItemDetailInfo.getInfo(item);
		return (
			<div
				id={"item-row-small-" + idx}
				className={"personal-inventory__list-item-list personal-inventory__list-item-list--small-size " +
					((bQtyUpdated && !bQtyError) ? "personal-inventory__list-qty-updated " : (bQtyUpdated && bQtyError) ? "personal-inventory__list-qty-update-err" : (idx % 2 == 1) ? "personal-inventory__list-even" : "") +
					(item.markedAsDeletion ? "" : " l-border--bottom")
				}
				key={"itemlist-sm" + idx}
			>
				{this.renderSmallSizeItemImgCol(item, idx)}
				{this.renderSmallSizeItemNameCol(item, idx)}
				
				<div className="personal-inventory__hide-mobile personal-inventory__cell--item-qty">
					<div className="l-flex">
						<div className="l-half-width text--center">Qty</div>
						<div className="l-half-width">&nbsp;</div>
					</div>
					<div className="l-flex">
						<div className="l-half-width">
							<input className={"text-input text--center " + (bMarkedAsDeletion ? "text--disabled" : "")} name={"invQty-item-" + idx} type="number" value={qty} disabled={bMarkedAsDeletion} onKeyPress={(e) => this.checkKey(e)} onChange={(e) => this.props.func.updateItemQty(idx, e.target.value)} />
						</div>
						<div className={"l-half-width text--center l-margin-y--auto"}>
							<div className={" personal-inventory__icon-delete-list" + ((bMarkedAsDeletion) ? " personal-inventory__icon-delete-marked" : "") + " l-margin-x--auto"}>
								<div className={"icon-delete l-margin-y--auto l-flex l-center-v l-center l-full-height" + ((bQtyUpdated) ? " text--disabled" : "")} onClick={() => this.markAsDeletion(idx, item)}>
									<i className="fa-regular fa-trash-can icon-delete"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="personal-inventory__show-only-mobile personal-inventory__list-item-list-cell--1">
					<div className="l-flex l-end l-column">
						<div className="text--center l-full-width">
							<div>
								Qty
							</div>
							<div>
								<input className={"text-input text--center " + (bMarkedAsDeletion ? "text--disabled" : "")} name={"invQty-item-" + idx} type="number" value={qty} disabled={bMarkedAsDeletion} onKeyPress={(e) => this.checkKey(e)} onChange={(e) => this.props.func.updateItemQty(idx, e.target.value)} />
							</div>
						</div>
					</div>
				</div>
				{this.renderSmallSizeItemNoteCol(item, idx)}
			</div>
		)
	}

	renderSmallSizeItemNoteCol(item, idx) {
		const { itemNoSeq, thumbUrl } = ItemDetailInfo.getInfo(item);
		return(
			<div className="personal-inventory__cell--note l-margin-top--sm personal-inventory__note-field">
				{this.renderNoteContent(item, idx)}
			</div>

		)
	}

	renderSmallSizeItemImgCol(item, idx) {
		const { itemType, itemNoSeq, itemColorId, thumbUrl } = ItemDetailInfo.getInfo(item);
		return (
			<div className="personal-inventory__cell--image personal-inventory__small-list-image-col">
				<div className="personal-inventory__set-list-image">
					{this.renderItemThumb(thumbUrl, idx)}
				</div>
				<div className="text--small text--center l-margin-top--sm text--break-word l-cursor-pointer" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>{itemNoSeq}</div>
			</div>
		)
	}

	renderFullSizeItemNoteCol(dispItemType, item, idx) {
		const { showCategoryTree } = this.props.data;
		const { bQtyUpdated, bNoteUpdated, bMarkedAsDeletion } = ItemDetailInfo.getInfo(item);
		const classCell = (dispItemType == "P")?"personal-inventory__list-item-list-cell--p-note":"personal-inventory__list-item-list-cell--note";
		
		return (
			<div className={classCell}>
				<div className="l-flex">
					<div className="l-full-width l-margin-right--sm  personal-inventory__note-field">
						{this.renderNoteContent(item, idx)}
					</div>
					{showCategoryTree && // ADD DELETE ICON
						<div id={"icon-delete-" + idx}
							className={"icon-delete personal-inventory__icon-delete-list" + ( (showCategoryTree)?"--with-category-tree":"" ) + ((bMarkedAsDeletion) ? " personal-inventory__icon-delete-marked" : "") + " l-margin-x--auto"}
							onClick={() => this.markAsDeletion(idx, item)}
						>
							<div className={"icon-delete l-margin-y--auto l-flex l-center-v l-center l-full-height" + ((bQtyUpdated || bNoteUpdated) ? " text--disabled" : "")}>
								<i className="fa-regular fa-trash-can icon-delete"></i>
							</div>
						</div>
					}
				</div>
			</div>
		)
	}

	updateNoteContent(idx, newNote, e) {
		if (e.target.value != newNote) {
			e.target.style.height = 'inherit';
			e.target.style.height = e.target.scrollHeight + "px"; 
			
			this.props.func.updateNoteContent(idx, e.target.value);
			const arrTextArea = document.getElementsByClassName("TextareaNote-" + idx);
			for (var i = 0; i < arrTextArea.length;i++) {
				arrTextArea[i].value = e.target.value;
			}
		}
	}

	focusTextarea(idx) {
		const noteArea = document.getElementById("SectionEditNote-" + idx);
		if (noteArea != null) {
			noteArea.classList.remove("l-border");
			noteArea.classList.add("personal-inventory__border-primary-blue");
		}
	}

	blurTextarea(idx) {
		const noteArea = document.getElementById("SectionEditNote-" + idx);
		if (noteArea != null) {
			noteArea.classList.add("l-border");
			noteArea.classList.remove("personal-inventory__border-primary-blue");
		}
	}

	renderNoteContent(item, idx) {
		const { note, newNote, bNoteEnabled, bNoteUpdated, bMarkedAsDeletion } = ItemDetailInfo.getInfo(item);
		const notesInTextarea = (newNote == "")?"":newNote;
		const notesToDisplay = (bNoteUpdated)?newNote:note;
		const maxNoteLen = this.props.data.myCollectionConfig.maxNoteLen;
		const notesInTextareaLen = notesInTextarea.length;

		if (bNoteEnabled) {
			return (
				<div 
					id={"SectionEditNote-" + idx}
					className="l-border personal-inventory__section-note-textarea"
				>
					<textarea
						id={"TextareaNote-" + idx} 
						className={"personal-inventory__textarea-note l-border--null l-full-width l-pad-y--sm l-pad-x cls-txtarea-note TextareaNote-" + idx }
						maxLength={maxNoteLen} 
						onKeyUp={(e) => this.updateNoteContent(idx, newNote, e)}
						defaultValue={notesInTextarea}
						placeholder="Type your notes here"
						disabled={bMarkedAsDeletion}
						onFocus={() => this.focusTextarea(idx)}
						onBlur={() => this.blurTextarea(idx)}
					>
					</textarea>
					<div className="l-pad-bottom--sm l-pad-x text--small text--right text--darkest48">{notesInTextareaLen}/{maxNoteLen}</div>
				</div>
			)
		}
		else {

			const strNotes = (notesToDisplay == "")?"":notesToDisplay;

			if (strNotes == "") {
				return(
					<React.Fragment>
						<button className={"btn btn--blank " + ( (bMarkedAsDeletion)?"text--disabled":"" )} onClick={()=>this.enableEditNote(idx, bMarkedAsDeletion)}><i className="far fa-edit"></i> Add notes</button>
					</React.Fragment>
				)
			}
			else
			{
				return(
					<React.Fragment>
						{strNotes}
						<div>
							<button className={"btn btn--link text--small" + ( (bMarkedAsDeletion)?"text--disabled":"" )} onClick={()=>this.enableEditNote(idx, bMarkedAsDeletion)}>edit</button>
						</div>
					</React.Fragment>
				)

			}
		}
	}

	renderFullSizeItemDelCol(itemType, item, idx) {
		const { showCategoryTree } = this.props.data;
		const { bQtyUpdated, bNoteUpdated, bMarkedAsDeletion } = ItemDetailInfo.getInfo(item);
		const classCell = (itemType == "P")?"personal-inventory__list-item-list-cell--p-del":"personal-inventory__list-item-list-cell--del";

		if (showCategoryTree) {
			return null;
		}
		return (
			<div className={classCell}>
				<div id={"icon-delete-" + idx}
					className={"icon-delete personal-inventory__icon-delete-list" + ((bMarkedAsDeletion) ? " personal-inventory__icon-delete-marked" : "") + " l-margin-x--auto"}
					onClick={() => this.markAsDeletion(idx, item)}
				>
					<div className={"icon-delete l-margin-y--auto l-flex l-center-v l-center l-full-height" + ((bQtyUpdated || bNoteUpdated) ? " text--disabled" : "")}>
						<i className="fa-regular fa-trash-can icon-delete"></i>
					</div>
				</div>
			</div>
		)
	}

	renderFullSizeItemQtyCol(itemType, item, idx) {
		const { qty, bMarkedAsDeletion } = ItemDetailInfo.getInfo(item);
		const classCell = (itemType == "P")?"personal-inventory__list-item-list-cell--p-qty":"personal-inventory__list-item-list-cell--qty";
		return (
			<div className={classCell}>
				<input className={"text-input text--center personal-inventory__list-qty " + (bMarkedAsDeletion ? "text--disabled" : "")} name={"invQty-item-" + idx} type="number" value={qty} disabled={bMarkedAsDeletion} onKeyPress={(e) => this.checkKey(e)} onChange={(e) => this.props.func.updateItemQty(idx, e.target.value)} />
			</div>
		)
	}

	renderFullSizeItemConditionCol(itemType, strItemCondition) {
		const classCell = (itemType == "P")?"personal-inventory__list-item-list-cell--p-cond":"personal-inventory__list-item-list-cell--cond";
		return (
			<div className={classCell}>{strItemCondition}</div>
		)
	}

	renderFullSizeItemImgCol(item, idx) {
		const { dispItemType } = this.props.data;
		const { itemType, thumbUrl, itemNoSeq, itemColorId } = ItemDetailInfo.getInfo(item);
		const classCell = (dispItemType == "P")?"personal-inventory__list-item-list-cell--p-image":"personal-inventory__list-item-list-cell--image";
		return (
			<div className={classCell + " personal-inventory__set-list-image l-cursor-pointer"} onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>
				{this.renderItemThumb(thumbUrl, idx)}
			</div>
		)
	}

	renderFullSizeItemNoCol(itemType, itemNoSeq, itemColorId) {
		const { dispItemType } = this.props.data;
		const classCell = (dispItemType == "P")?"personal-inventory__list-item-list-cell--p-item-no":"personal-inventory__list-item-list-cell--item-no";
		return (
			<div className={classCell + " text--break-word l-cursor-pointer"} onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>{itemNoSeq}</div>
		)
	}

	renderFullSizeItemNameCol(item, idx) {
		const { dispItemType } = this.props.data;
		const { itemName, itemType, itemNoSeq, invURL, catNames, catIds, ci, catString, isRenderColorInfo, itemColorId } = ItemDetailInfo.getInfo(item);
		const hasColor = ((ci != null) && ((itemType == "P") || (itemType == "G"))) ? true : false;
		if (dispItemType == "P") {

			return (
				<React.Fragment>
					<div className={"personal-inventory__list-item-list-cell--p-item-name"}>
						<div className="text--bold personal-inventory__list-item-name l-cursor-pointer" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>{itemName}</div>
						<div className="personal-inventory__item-category"><CategoryLinks data={{ itemType: item.itemType, catNames: catNames, catIds: catIds, catString: catString }} /></div>
					</div>
					<div className="personal-inventory__list-item-list-cell--p-color">{isRenderColorInfo && this.renderColor(ci)}</div>
				</React.Fragment>
			)
		}
		else if (dispItemType == "A") {
			return (
				<div className="personal-inventory__list-item-list-cell--item-name">
					<div className="text--bold l-cursor-pointer" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>{itemName}</div>
					<div className="personal-inventory__item-category l-flex"><div className="l-margin-right--xs text--bold l-nowrap">{ItemTypeNameUtil.getFullName(itemType)} : </div><CategoryLinks data={{ itemType: itemType, catNames: catNames, catIds: catIds, catString: catString }} /></div>
					<div className="l-margin-top--xs text--small">{isRenderColorInfo && this.renderColor(ci)}</div>
					{(item.invYN == "Y") && <div><a href={invURL}>see inventory ></a></div>}
				</div>
			)
		}
		else {
			return (
				<div className="personal-inventory__list-item-list-cell--item-name">
					<div className="text--bold l-cursor-pointer" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>{itemName}</div>
					<div className="personal-inventory__item-category"><CategoryLinks data={{ itemType: itemType, catNames: catNames, catIds: catIds, catString: catString }} /></div>
					<div className="text--small">{isRenderColorInfo && this.renderColor(ci)}</div>
					{(item.invYN == "Y") && <div><a href={invURL}>see inventory ></a></div>}
				</div>
			)
		}

	}

	renderSmallSizeItemNameCol(item, idx) {
		const { dispItemType } = this.props.data;
		const { itemType, itemNoSeq, itemName, strItemCondition, invURL, catNames, catIds, ci, bQtyUpdated, bQtyError, qty, isRenderColorInfo, bMarkedAsDeletion, itemColorId } = ItemDetailInfo.getInfo(item);
		const hasColor = ((ci != null) && ((itemType == "P") || (itemType == "G"))) ? true : false;
		return (

			<React.Fragment>
			{((dispItemType != "P") && (dispItemType != "M") && (dispItemType != "G") && (dispItemType != "A")) &&
				<React.Fragment>
					<div className="personal-inventory__hide-mobile personal-inventory__cell--item-name">
						<div className="personal-inventory__list-item-name text--bold l-cursor-pointer" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>{itemName}</div>
						<div className="personal-inventory__item-category text--small"><CategoryLinks data={{ itemType: item.itemType, catNames: catNames, catIds: catIds, catString: item.catString }} /></div>
						<div className="text--small">{strItemCondition}</div>
						{(item.invYN == "Y") && <div className="text--small"><a href={invURL}>see inventory ></a></div>}
					</div>
					<div className="personal-inventory__show-only-mobile personal-inventory__cell--item-name">
						<div className="personal-inventory__list-item-name text--bold l-cursor-pointer" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>{itemName}</div>
						<div className="personal-inventory__item-category text--small"><CategoryLinks data={{ itemType: item.itemType, catNames: catNames, catIds: catIds, catString: item.catString }} /></div>
						<div className="text--small">{strItemCondition}</div>
						{(item.invYN == "Y") && <div className="text--small"><a href={invURL}>see inventory ></a></div>}
					</div>
				</React.Fragment>
			}
			{(((dispItemType == "P") || (dispItemType == "M") || (dispItemType == "G"))) &&
				<React.Fragment>
					<div className="personal-inventory__hide-mobile personal-inventory__cell--item-name">
						<div className="personal-inventory__list-item-name text--bold l-cursor" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>
							{itemName}
						</div>
						<div className="personal-inventory__item-category text--small"><CategoryLinks data={{ itemType: item.itemType, catNames: catNames, catIds: catIds, catString: item.catString }} /></div>
						<div className="text--small">{strItemCondition}</div>
						<div className="personal-inventory__list-item-list-cell--2 text--small">{isRenderColorInfo && this.renderColor(ci)}</div>
					</div>
					<div className="personal-inventory__show-only-mobile personal-inventory__cell--item-name">
						<div className="personal-inventory__list-item-name text--bold l-cursor" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>
							{itemName}
						</div>
						<div className="personal-inventory__item-category text--small"><CategoryLinks data={{ itemType: item.itemType, catNames: catNames, catIds: catIds, catString: item.catString }} /></div>
						<div className="text--small">{strItemCondition}</div>
						<div className="personal-inventory__list-item-list-cell--2 text--small">{isRenderColorInfo && this.renderColor(ci)}</div>
					</div>
				</React.Fragment>
			}
			{((dispItemType == "A")) &&
				<React.Fragment>
					<div className="personal-inventory__hide-mobile personal-inventory__cell--item-name">
						<div className="personal-inventory__list-item-name text--bold l-cursor-pointer" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>{itemName}</div>
						<div className="personal-inventory__item-category text--small l-flex"><div className="l-margin-right--xs text--bold l-nowrap">{ItemTypeNameUtil.getFullName(itemType)} : </div><CategoryLinks data={{ itemType: item.itemType, catNames: catNames, catIds: catIds, catString: item.catString }} /></div>
						<div className="personal-inventory__list-item-list-cell--2 text--small">{isRenderColorInfo && this.renderColor(ci)}</div>
						<div className="text--small">{strItemCondition}</div>
						{(item.invYN == "Y") && <div className="text--small"><a href={invURL}>see inventory ></a></div>}
					</div>
					<div className="personal-inventory__show-only-mobile personal-inventory__cell--item-name">
						<div className="personal-inventory__list-item-name text--bold l-cursor-pointer" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>{itemName}</div>
						<div className="personal-inventory__item-category text--small l-flex"><div className="l-margin-right--xs text--bold l-nowrap">{ItemTypeNameUtil.getFullName(itemType)} : </div><CategoryLinks data={{ itemType: item.itemType, catNames: catNames, catIds: catIds, catString: item.catString }} /></div>
						<div className="personal-inventory__list-item-list-cell--2 text--small">{isRenderColorInfo && this.renderColor(ci)}</div>
						<div className="text--small">{strItemCondition}</div>
						{(item.invYN == "Y") && <div className="text--small"><a href={invURL}>see inventory ></a></div>}
					</div>
				</React.Fragment>
			}
			</React.Fragment>
		)
	}

	renderItemThumb(thumbUrl, idx) {
		return (
			<React.Fragment>
				<img className="personal-inventory__list-thumb-img" id={"itemImg-" + idx} src={thumbUrl} onError={() => this.imgErrorProc(idx)} />
				<div id={"noItemImg-" + idx} className="l-center-v l-full-height l-full-width text--center l-hide">
					<div className="l-margin-y--auto l-flex l-center-v l-center l-full-height">
						<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fillRule="evenodd" clipRule="evenodd" d="m30.495 9.505-.623-.624A3 3 0 0 0 27.753 8H15A3.01 3.01 0 0 0 12 11.006V28l3-3V11.007h9.997v3.997l3-3v-.754l.377.377 2.121-2.121zM17.313 34l4.842-4.842.843.843 5.467-5.468a.75.75 0 0 1 1.063 0l1.468 1.469V34H17.313zm-2.314 2.313v.687h17.997V19.004h-.686l3.572-3.572c.074.264.113.539.113.816v20.753a3 3 0 0 1-3 2.999H15a2.996 2.996 0 0 1-2.436-1.25L15 36.314zm5.869-17.182a3 3 0 0 0-3.74 3.74l3.74-3.74zM37.414 8.414a2 2 0 0 1 0 2.829L10.243 38.414a2 2 0 1 1-2.829-2.828L34.586 8.414a2 2 0 0 1 2.828 0z" fill="#0A1E32" />
						</svg>
					</div>
				</div>
			</React.Fragment>
		)
	}

	enableEditNote(idx, bMarkedAsDeletion) {
		if (!bMarkedAsDeletion) {
			this.setState({focusOn: idx});
			this.props.func.enableEditNote(idx);
		}
	}

	updateSortingOptions(sortType, sortDirection) {
		const { listItem, itemType, listingOptions } = this.props.data;
		if (sortType != listingOptions.nListSortType) {
			this.props.func.updateSortType(sortType);
		}
		else {
			this.props.func.updateSortOrder();
		}
	}

	detectSwipeActionRes(start, end) {
		const minSwipeDistance = 75;
		const distance = start - end;
		const isRtoLSwipe = distance > minSwipeDistance;
		const isLtoRSwipe = distance < -1 * minSwipeDistance;
		return { RtoLSwipe: isRtoLSwipe, LtoRSwipe: isLtoRSwipe };
	}

	onSwipeStart(e, item, idx) {
		if ((!item.markedAsDeletion) && (window.innerWidth < 568)) {
			this.start = e.changedTouches[0].clientX;
			this.colHeight = $("#item-row-small-" + idx).height();
		}
	}

	onSwipeMoving(e, item, idx) {
		if ((!item.markedAsDeletion) && (window.innerWidth < 568)) {
			this.end = e.changedTouches[0].clientX;
			const action = this.detectSwipeActionRes(this.start, this.end);

			if (action.RtoLSwipe) {
				$("#item-row-small-" + idx).hide();
				$("#listItemView-swipe-trash-" + idx).css("display", "grid");
				$("#listItemView-swipe-trash-" + idx).height(this.colHeight);

			}
			else {
				$("#item-row-small-" + idx).show();
				$("#listItemView-swipe-trash-" + idx).hide();
			}
		}
	}

	onSwipeEnd(e, item, idx) {
		
		const { bQtyUpdated, bNoteUpdated } = ItemDetailInfo.getInfo(item);

		if ((!item.markedAsDeletion) && (window.innerWidth < 568)) {
			$("#item-row-small-" + idx).show();
			$("#listItemView-swipe-trash-" + idx).hide();

			const minSwipeDistance = 75;
			this.end = e.changedTouches[0].clientX
			const action = this.detectSwipeActionRes(this.start, this.end);

			if (action.LtoRSwipe) this.props.func.markAsDeletion(idx, false);
			if (!bNoteUpdated && !bQtyUpdated && action.RtoLSwipe) this.props.func.markAsDeletion(idx, true);
		}

	}

	isEmptyList(listItem) {
		for (const item of listItem) {
			if (item.invQty > 0) return false;
		}
		return true;
	}

	getItemView(listItem) {
		let listItemView = listItem.map((item, idx) => {
			const { itemName, itemType, itemNoSeq, strItemCondition, invURL, catNames, catIds, ci, bQtyUpdated, qty, isRenderColorInfo, bMarkedAsDeletion, itemColorId } = ItemDetailInfo.getInfo(item);
			return (
				<div key={"listItemView-" + idx} id={"listItemView-" + idx} onTouchStart={(e) => this.onSwipeStart(e, item, idx)} onTouchMove={(e) => this.onSwipeMoving(e, item, idx)} onTouchEnd={((e) => this.onSwipeEnd(e, item, idx))} >
					{this.renderItemRowFullSize(item, idx)}

					{this.renderItemRowSmallSize(item, idx)}


					{bMarkedAsDeletion &&
						<div className="personal-inventory__show-only-mobile personal-inventory__list-item-list-cell--4">
							<div className="l-flex l-split personal-inventory__marked-delete-row text--small">
								<div>Marked for deletion</div>
								<div className="l-cursor-pointer text--underline" onClick={() => this.props.func.markAsDeletion(idx, !bMarkedAsDeletion)}>Undo</div>
							</div>
						</div>
					}

					<div id={"listItemView-swipe-trash-" + idx}
						className="personal-inventory__hide personal-inventory__list-item-list-del personal-inventory__list-item-list--small-size-swipe l-border--bottom">
						{((itemType != "P") && (itemType != "M") && (itemType != "G")) &&
							<React.Fragment>
								<div className="personal-inventory__show-only-mobile personal-inventory__cell--item-name">
									<div className="personal-inventory__list-item-name text--bold l-cursor-pointer" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>{itemName}</div>
									<div className="personal-inventory__item-category text--small"><CategoryLinks data={{ itemType: item.itemType, catNames: catNames, catIds: catIds, catString: item.catString }} /></div>
									<div className="text--small">{strItemCondition}</div>
									{(item.invYN == "Y") && <div className="text--small"><a href={invURL}>see inventory ></a></div>}
								</div>

							</React.Fragment>
						}
						{(((itemType == "P") || (itemType == "M") || (itemType == "G"))) &&
							<React.Fragment>
								<div className="personal-inventory__show-only-mobile personal-inventory__cell--item-name">
									<div className="personal-inventory__list-item-name text--bold l-cursor" onClick={() => Page.openItemDetailPage(itemType, itemNoSeq, itemColorId)}>
										{itemName}
									</div>
									<div className="personal-inventory__item-category text--small"><CategoryLinks data={{ itemType: item.itemType, catNames: catNames, catIds: catIds, catString: item.catString }} /></div>
									<div className="text--small">{strItemCondition}</div>
									<div className="personal-inventory__list-item-list-cell--2 text--small">{isRenderColorInfo && this.renderColor(ci)}</div>
								</div>
							</React.Fragment>
						}
						<div className="personal-inventory__show-only-mobile personal-inventory__cell--item-qty">
							<div className="l-flex l-end l-column">
								<div className="text--center l-full-width">
									<div>
										Qty
									</div>
									<div>
										<input className="text-input text--center" name={"invQty-item-" + idx} type="number" value={qty} onKeyPress={(e) => this.checkKey(e)} onChange={(e) => this.props.func.updateItemQty(idx, e.target.value)} />

									</div>
								</div>
							</div>
						</div>
						{this.renderSmallSizeItemNoteCol(item, idx)}
						<div className="personal-inventory__show-only-mobile personal-inventory__cell--del">
							<div className="l-flex l-end l-column l-full-height">
								<div className={"personal-inventory__list-col-trash l-full-height l-flex l-center-v l-center" + ((bQtyUpdated) ? " text--disabled" : "")}>
									<i className="fa-regular fa-trash-can icon-delete"></i>
								</div>
							</div>
						</div>

					</div>
				</div>
			)
		});
		return listItemView;
	}

	moveToItemDetail(item) {
		let itemNoSeq = item.itemNo;
		if (item.itemSeq >= 1) {
			itemNoSeq = itemNoSeq + "-" + item.itemSeq;
		}

		let clickURL = "//" + blapp.config.getHost("www") + "/v2/catalog/catalogitem.page?" + item.itemType + "=" + itemNoSeq;
		//window.location.href = clickURL;

	}

	markAsDeletion(idx, item) {
		const { bQtyUpdated, bNoteUpdated, bMarkedAsDeletion } = ItemDetailInfo.getInfo(item);
		if (!bQtyUpdated && !bNoteUpdated) this.props.func.markAsDeletion(idx, !bMarkedAsDeletion);
		return null;
	}

	imgErrorProc(idx) {
		$("#itemImg-" + idx).hide();
		$("#noItemImg-" + idx).show();
		$("#itemImg-sm-" + idx).hide();
		$("#noItemImg-sm-" + idx).show();
	}

	getStrItemCondition(item) {
		const itemType = this.props.data.itemType;
		let strItemCondition = (item.invNew == "N") ? "New" : (item.invNew == "U") ? "Used" : "";

		if (itemType !== "P") {
			strItemCondition += (item.invComplete == "C") ? ", Complete" : (item.invComplete == "I") ? ", Incomplete" : (item.invComplete == "S") ? ", Sealed" : "";
		}
		return strItemCondition;
	}

	checkKey(e) {
		if (event.key === 'Enter') {
			this.props.func.saveInvChanges();
		}
	}
};

